var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.412 19.924A10.44 10.44 0 0019.917 9.418v-.482a7.691 7.691 0 001.833-1.907 7.618 7.618 0 01-2.12.581 3.73 3.73 0 001.637-2.045 7.274 7.274 0 01-2.34.9 3.698 3.698 0 00-6.3 3.363 10.465 10.465 0 01-7.609-3.854 3.69 3.69 0 001.146 4.909 3.658 3.658 0 01-1.637-.458v.04a3.707 3.707 0 002.905 3.642 3.707 3.707 0 01-1.637.065 3.69 3.69 0 003.42 2.528 7.405 7.405 0 01-4.59 1.637 8.018 8.018 0 01-.875-.074 10.448 10.448 0 005.662 1.636"
  })));
}
export default SvgSocialTwitter;